export const getCourseNameFromUrl = () => {
  try {
    const pathname = window.location.pathname;
    
    const coursePathRegex = /(?:\/e-learning)?\/detalle\/(carrera|curso|diplomatura|experto-universitario|posgrado)\/\d+\/([^\/\?]+)/i;
    const match = pathname.match(coursePathRegex);
    
    if (match && match[2]) {
      return match[2]
        .replace(/-/g, ' ')
        .replace(/_/g, ' ')
        .replace(/\+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
        .replace(/\b\w/g, l => l.toUpperCase());
    }
    
    return 'unknown';
  } catch (error) {
    console.error('Error extracting course name from URL:', error);
    return 'unknown';
  }
}; 